import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { UtilsModule } from '@gallaghercp/core-frontend';

import {
    adapterFactory,
    CalendarModule,
    DateAdapter,
} from '@gallaghercp/core-calendar';
import { CampusSelectComponent } from '@core-app/layout/nav/top-nav/campus-select/campus-select.component';
import { BlockClientLanguageComponent } from '@core-app/client/blocks/block-language/block-language.component';
import {
    BsDropdownDirective,
    BsDropdownMenuDirective,
    BsDropdownToggleDirective,
} from 'ngx-bootstrap/dropdown';

@NgModule({
    declarations: [CampusSelectComponent, BlockClientLanguageComponent],
    imports: [
        CommonModule,
        TranslateModule,
        UtilsModule,
        CalendarModule.forRoot({
            provide: DateAdapter,
            useFactory: adapterFactory,
        }),
        BsDropdownMenuDirective,
        BsDropdownToggleDirective,
        BsDropdownDirective,
    ],
    exports: [CampusSelectComponent, BlockClientLanguageComponent],
})
export class ClientModule {}
